"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseApiClient = void 0;
const axiosClientFactory_1 = require("./utils/axiosClientFactory");
const adonis_client_1 = require("@utex/adonis-client");
class BaseApiClient {
    constructor(options, logger, schema, getTokens, getTraceId) {
        this.clients = {};
        this.schema = schema;
        if (options && !options.logger) {
            this.config = options;
            this.logger = logger;
            if (this.config.rest) {
                this.clients.rest = (0, axiosClientFactory_1.axiosClientFactory)(this.config.rest, undefined, getTraceId);
                this.clients.securedRest = (0, axiosClientFactory_1.axiosClientFactory)(this.config.rest, getTokens, getTraceId);
            }
            if (this.config.stream) {
                this.clients.stream = new adonis_client_1.AdonisClient(this.config.stream, this.logger, getTokens);
            }
        }
        else {
            const objectOptions = options;
            this.config = objectOptions.config;
            this.logger = objectOptions.logger;
            if (this.config.rest) {
                this.clients.rest = (0, axiosClientFactory_1.axiosClientFactory)(this.config.rest, undefined, objectOptions.getTraceId);
                this.clients.securedRest = (0, axiosClientFactory_1.axiosClientFactory)(this.config.rest, objectOptions.getTokens, objectOptions.getTraceId, objectOptions.removeTokens);
            }
            if (this.config.stream) {
                this.clients.stream = new adonis_client_1.AdonisClient(this.config.stream, this.logger, objectOptions.getTokens);
            }
        }
    }
    onLogout() {
        if (this.clients.stream) {
            this.clients.stream.logout();
        }
    }
    destroy() {
        this.onLogout();
    }
}
exports.BaseApiClient = BaseApiClient;
//# sourceMappingURL=BaseApiClient.js.map